import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Tipo de Documento',
        path: '/biblioteca/bibtipodocumento',
        name: 'bibtipodocumento',
        component: () => import('@/views/biblioteca/bibtipodocumento/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_TIPODEDOCUMENTONOVO_MENU_1300800199],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Tipo de Documento',
        path: '/biblioteca/bibtipodocumento/cadastro/:id?',
        parent: 'bibtipodocumento',
        name: 'bibtipodocumento_create',
        component: () => import('@/views/biblioteca/bibtipodocumento/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_TIPODEDOCUMENTONOVO_MENU_1300800199],
        },
        goesToMenu: true,
    },
]
